import Schema, { array, obj } from 'AppReact/schema';
import { assignTech } from 'types';

export default {
  selectedDate: Schema('jsDate', 'primitive'),
  startTime: Schema('string', 'primitive'),
  endTime: Schema('string', 'primitive'),
  totalHours: Schema('string', 'primitive'),
  totalHoursError: Schema('string', 'primitive-nullable', { defaultValue: null }),
  startDateTimeOriginal: Schema('jsDate', 'primitive'),
  endDateTimeOriginal: Schema('jsDate', 'primitive'),
  payloadStartDateTime: Schema('jsDate', 'primitive'),
  payloadEndDateTime: Schema('jsDate', 'primitive'),
  event_id: Schema('integer', 'primitive'),
  order_id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  request_id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  isDirty: Schema('boolean', 'primitive', { defaultValue: false }),
  showOnTop: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  techId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  techs: Schema(assignTech, 'array', { defaultValue: [] })
};
